module.exports = __webpack_public_path__ + "static/img/pinpai-11.7d2ff832.png";